import React, { memo, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { CAMPAIGNS_MARKETING } from 'constants/Entities';
import EntityDetail from 'containers/components/EntityDetail';
import EntityDetailWrapper from 'containers/components/EntityDetail/EntityDetailWrapper';
import EntityDetailHeader from 'containers/components/EntityDetail/EntityDetailHeader';
import EntityDetailContent from 'containers/components/EntityDetail/EntityDetailContent';
import { getLiteral } from 'utils/getLiteral';

import CampaignDetails from 'containers/campaigns/marketing/CampaignDetails';
import useMarketingCampaignsDetail from './hooks/useMarketingCampaignsDetail';

import './MarketingCampaignsDetail.scss';

const TAB_SUMMARY = 'summary';
const TAB_RECIPIENTS = 'recipients';

const MarketingCampaignsDetail = memo(() => {
    const location = useLocation();
    const { className, entity, getOptions, onDeleteEntity, width } = useMarketingCampaignsDetail();

    const currentTab = useMemo(() => {
        const detailPathPrefix = `${CAMPAIGNS_MARKETING.route}/`;
        const pathname = location.pathname || '';

        if (!pathname.startsWith(detailPathPrefix)) {
            return TAB_SUMMARY;
        }

        const detailPath = pathname.slice(detailPathPrefix.length);
        const [, tab] = detailPath.split('/');

        if (tab === TAB_RECIPIENTS) {
            return TAB_RECIPIENTS;
        }

        return TAB_SUMMARY;
    }, [location.pathname]);

    return (
        <EntityDetail className={className} entity={entity} width={width}>
            {({ renderLoader, loading, data, close }) => (
                <EntityDetailWrapper>
                    <EntityDetailHeader
                        close={close}
                        data={data}
                        entity={entity}
                        loading={loading}
                        modalCancelText={getLiteral('action_cancel')}
                        modalConfirmText={getLiteral('action_delete')}
                        modalContent={getLiteral(
                            'label_marketing_campaigns_delete_campaign_confirm_modal_message',
                        )}
                        modalTitle={getLiteral(
                            'title_marketing_campaigns_delete_campaign_confirm_modal',
                        )}
                        onDelete={onDeleteEntity}
                        options={getOptions(data)}
                        title={data?.name ?? ''}
                    />
                    <EntityDetailContent>
                        {loading && renderLoader()}
                        {!loading && data && (
                            <CampaignDetails campaign={data} initialTabKey={currentTab} />
                        )}
                    </EntityDetailContent>
                </EntityDetailWrapper>
            )}
        </EntityDetail>
    );
});

MarketingCampaignsDetail.displayName = 'MarketingCampaignsDetail';

export default MarketingCampaignsDetail;
